var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:( _obj = {'is-small': _vm.small, 'is-loading': _vm.loading, 'is-disabled': _vm.disabled}, _obj[_vm.themeClass] = true, _obj ),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }